// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__32B5t","author":"Table_author__2z-j-","authorImage":"Table_authorImage__17TEV","unreadRow":"Table_unreadRow__1_F30"};